// src/services/TerminalPagamentoService.js

const integradoresDisponiveis = [0, 1, 2, 5];

export const obterIntegradorTerminal = (terminal) => Number(
  terminal?.integrador ?? terminal?.Integrador ?? 0
);

export const terminalSemTef = (terminal) => (
  Number(terminal?.id) > 0 && obterIntegradorTerminal(terminal) === 0
);

export const formaUsaTef = (formaPag) => (
  formaPag?.usaTef === true
  && Number(formaPag.meioPag) !== 1
);

export const deveProcessarTEF = (formaPag, terminal) => (
  formaUsaTef(formaPag) && !terminalSemTef(terminal)
);

export const terminalDisponivelPagamento = (terminal) => (
  Number(terminal?.id) > 0 && integradoresDisponiveis.includes(obterIntegradorTerminal(terminal))
);

export const obterTerminalIdPagamento = (pagamento) => (
  pagamento?.configTEFid ?? pagamento?.configTEFId ?? null
);

export const pagamentoBloqueiaTerminal = (pagamento) => {
  if (Number(pagamento?.statusTEF) === 3 && pagamento?.pago !== true) return false;
  return [1, 2].includes(Number(pagamento?.statusTEF))
    || (Number(pagamento?.superTefId) > 0 && Number(pagamento?.statusTEF) !== 3)
    || Boolean(pagamento?.tefAutorizacao)
    || (pagamento?.pago === true
      && Boolean(obterTerminalIdPagamento(pagamento)));
};

export const terminalVendaBloqueado = (pagamentos = []) => (
  pagamentos.some(pagamentoBloqueiaTerminal)
);

export const obterTerminalRegistradoVenda = (pagamentos = [], terminais = []) => {
  const pagamento = pagamentos.find((item) => (
    obterTerminalIdPagamento(item) && pagamentoBloqueiaTerminal(item)
  )) || pagamentos.find((item) => obterTerminalIdPagamento(item));
  const terminalId = obterTerminalIdPagamento(pagamento);
  if (!terminalId) return null;
  const terminal = terminais.find((item) => Number(item.id) === Number(terminalId));
  if (!terminal) {
    throw new Error('O terminal registrado nesta venda não está disponível.');
  }
  return terminal;
};

export const validarTerminalVenda = (pagamentos = [], terminal) => {
  const pagamentosTef = pagamentos.filter((pagamento) => formaUsaTef(pagamento?.formaPag));
  if (!pagamentosTef.length) return;
  if (!terminal?.id) {
    throw new Error('Selecione o terminal que processará o pagamento.');
  }
  if (!terminalDisponivelPagamento(terminal)) {
    throw new Error('O integrador selecionado ainda não está disponível para pagamentos.');
  }
  if (!terminalSemTef(terminal) && pagamentosTef.some(p =>
    Number(p.formaPag?.meioPag) === 99 && obterIntegradorTerminal(terminal) !== 5)) {
    throw new Error('A forma TEF Manual exige um terminal com integrador Manual.');
  }
  if (pagamentos.some((pagamento) => (
    pagamentoBloqueiaTerminal(pagamento)
    && obterTerminalIdPagamento(pagamento)
    && Number(obterTerminalIdPagamento(pagamento)) !== Number(terminal.id)
  ))) {
    throw new Error('Não é possível trocar o terminal de uma venda com pagamento TEF em andamento ou já processado.');
  }
};

export const prepararPagamentosTerminal = (pagamentos = [], terminal) => {
  validarTerminalVenda(pagamentos, terminal);
  return pagamentos.map((pagamento) => {
    if (!formaUsaTef(pagamento?.formaPag) || pagamentoBloqueiaTerminal(pagamento)) {
      return pagamento;
    }
    const semTef = terminalSemTef(terminal);
    const atualizado = {
      ...pagamento,
      configTEFid: terminal.id,
      tefNaoIntegrado: semTef
    };
    if (semTef) {
      Object.assign(atualizado, {
        statusTEF: null,
        tefAutorizacao: null,
        tefNsu: null,
        tefBandeira: null,
        tefDataHora: null,
        cnpjCreden: null,
        superTefId: null,
        tefSerieTerminal: null,
        tefComprovante: null,
        tefComprovanteCliente: null,
        tefComprovanteEstab: null
      });
    }
    return atualizado;
  });
};

export const pagamentoExigeTef = (pagamento, terminal) => (
  (pagamento?.tefNaoIntegrado !== true && pagamentoBloqueiaTerminal(pagamento))
  || deveProcessarTEF(pagamento?.formaPag, terminal)
);

